import { render, staticRenderFns } from "./BookingDetailsView.vue?vue&type=template&id=11635adf&scoped=true"
import script from "./BookingDetailsView.vue?vue&type=script&lang=js"
export * from "./BookingDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11635adf",
  null
  
)

export default component.exports